import { useState } from "react";
import { toast } from "sonner";
import { Download, Loader2 } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function FloatingPdfButton({ slug }) {
  const [loading, setLoading] = useState(false);

  const handleDownload = async () => {
    if (loading) return;
    setLoading(true);

    // 1) Try server-side PDF (WeasyPrint — high quality, editorial layout)
    try {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 6000);
      const res = await fetch(
        `${BACKEND_URL}/api/case-studies/${slug}/pdf`,
        { method: "GET", signal: controller.signal }
      );
      clearTimeout(timeout);

      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const contentType = res.headers.get("content-type") || "";
      if (!contentType.includes("pdf")) {
        throw new Error("unexpected content-type: " + contentType);
      }

      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `LinkSync-etude-de-cas-${slug}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
      toast.success("PDF téléchargé");
      return;
    } catch (e) {
      console.warn("Server PDF unavailable, falling back to print:", e);
    } finally {
      setLoading(false);
    }

    // 2) Fallback : browser print dialog (user can save as PDF)
    toast.info("Ouverture de la boîte d'impression — sauvegardez en PDF.", {
      duration: 3500,
    });
    setTimeout(() => window.print(), 400);
  };

  return (
    <button
      data-testid="floating-pdf-button"
      onClick={handleDownload}
      aria-label="Télécharger l'étude de cas au format PDF"
      className={`fixed bottom-6 right-6 z-50 group flex items-center gap-3 h-12 pl-4 pr-5 rounded-full backdrop-blur-xl bg-[#121214]/90 border border-white/15 hover:border-[#FF1493] text-white shadow-[0_10px_40px_-10px_rgba(255,20,147,0.4)] hover:shadow-[0_10px_40px_-5px_rgba(255,20,147,0.8)] transition-all ${loading ? "opacity-80" : ""}`}
    >
      {loading ? (
        <Loader2 className="w-4 h-4 animate-spin text-[#FF1493]" />
      ) : (
        <Download className="w-4 h-4 text-[#FF1493] group-hover:translate-y-0.5 transition" />
      )}
      <span className="text-sm font-medium tracking-tight">
        {loading ? "Génération…" : "Télécharger le PDF"}
      </span>
    </button>
  );
}
